import React from 'react'

export default ({ children }) => (
  <div style={{ maxWidth: 1600, margin: '0 auto' }}>{children}</div>
)
